import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "onBlur"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    inputKey: null,
    title: null,
    options: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', modelValue: string): void;
}), expose: any, slots: any, attrs: any }) {

const hintIsOpen = ref(false);





const handleBlur = (e: FocusEvent) => {
  if (!(e.currentTarget as Node).parentElement?.contains(e.relatedTarget as Node)) {
    hintIsOpen.value = false;
  }
};

const handleOptionClick = (option: string) => {
  emit('update:modelValue', option);
  hintIsOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: "f-w-b",
      for: __props.inputKey
    }, _toDisplayString(__props.title), 9, _hoisted_1),
    _createElementVNode("div", null, [
      _createElementVNode("input", {
        id: __props.inputKey,
        type: "text",
        name: __props.inputKey,
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue',
  ($event.target as HTMLInputElement).value))),
        onFocus: _cache[1] || (_cache[1] = () => (hintIsOpen.value = true)),
        onBlur: _withModifiers(handleBlur, ["self"])
      }, null, 40, _hoisted_2),
      (hintIsOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: option.value
                }, [
                  _createElementVNode("button", {
                    onClick: () => handleOptionClick(option.value)
                  }, _toDisplayString(option.text), 9, _hoisted_4)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})